// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__69ue0","type":"styles_type__1u-sl","choices":"styles_choices__2QG88"};